import styled from '@emotion/styled'
import { FadeInUp } from 'app/components/Common/Animation/FadeInUp'
import { Button } from 'app/components/Common/Button'
import { FlexBox } from 'app/components/Layout/FlexBox'
import { useVocabularyData } from 'app/utils/vocabulary'
import React, { memo, useEffect, useState } from 'react'

export interface Props {
  bookingButtonURL?: string
  contactsEmail?: string
  languageCode: string
  requestButtonURL?: string
}

export const Buttons = memo(function Buttons({
  bookingButtonURL,
  contactsEmail,
  languageCode,
  requestButtonURL,
}: Props) {
  const [loading, setloading] = useState(true)

  useEffect(() => {
    setTimeout(() => {
      setloading(false)
    }, 2000)
  }, [])

  return (
    <Container row wrap>
      {bookingButtonURL ? (
        <FadeInUp delay={loading ? 2.9 : 0}>
          <CTA
            label={useVocabularyData('book', languageCode)}
            rel="noopener"
            target="_blank"
            URL={bookingButtonURL}
          />
        </FadeInUp>
      ) : null}

      {requestButtonURL ? (
        <FadeInUp delay={loading ? 3 : 0}>
          <CTA
            label={useVocabularyData('request', languageCode)}
            URL={requestButtonURL}
            variant="full-dark"
          />
        </FadeInUp>
      ) : null}

      {contactsEmail ? (
        <FadeInUp delay={loading ? 3 : 0}>
          <CTA
            label={useVocabularyData('contacts-us', languageCode)}
            onClick={() => {
              typeof window.gtag !== 'undefined' &&
                window.gtag('event', 'Click', {
                  event_category: 'Website',
                  event_label: 'Email Address',
                })
            }}
            target="mailto"
            URL={contactsEmail}
            variant="full-dark"
          />
        </FadeInUp>
      ) : null}
    </Container>
  )
})

const Container = styled(FlexBox)`
  margin-top: 3rem;

  @media (max-width: 1199px) {
    display: block;
  }
`

const CTA = styled(Button)`
  margin-right: 0.75rem;

  @media (max-width: 767px) {
    width: 100%;
    margin: 0.75rem 0 0;
  }
`
